// src/context/CountyAgeDataContext.tsx
import { createContext, useContext, useEffect, useState } from "react";
import { DisaggregatedMetric } from "../services/types";
import { fetchAgeCountyData, orgId } from "../utils/dashboardUtils";

interface CountyAgeDataContextProps {
    children: React.ReactNode;
}

const CountyAgeDataContext = createContext<DisaggregatedMetric | null>(null);

export const CountyAgeDataProvider = ({ children }: CountyAgeDataContextProps) => {
    const [countyAgeData, setCountyAgeData] = useState<DisaggregatedMetric | null>(null);

    useEffect(() => {
        const loadData = async () => {
            const countyData = await fetchAgeCountyData(orgId, 1194, { type: "county", value: "06067" });
            setCountyAgeData(countyData);
        };
        loadData();
    }, []);

    return (
        <CountyAgeDataContext.Provider value={countyAgeData}>
            {children}
        </CountyAgeDataContext.Provider>
    );
};

export const useCountyAgeData = () => useContext(CountyAgeDataContext);